export default __webpack_public_path__ + "static/media/bg-masthead-3-320w.fa4b0bd2.webp";